// Open-redirect guard — plan §12.2 and invariant I20.
import { hasControlCharacter } from "./chars";

const PROBE_ORIGIN = "https://studside.invalid";
const MAX_LENGTH = 2048;

/** Signup routes a user must never be "returned" to — they would loop. */
const LOOP_PATHS = ["/join", "/welcome", "/resume"];

/**
 * Accepts only same-origin relative paths such as `/feed` or `/c/ui-ux?tab=about`.
 * Rejects absolute URLs, protocol-relative `//host`, backslash variants, control characters
 * and the signup loop paths.
 */
export function isSafeReturnTo(value: string | null | undefined): value is string {
  if (typeof value !== "string" || value.length === 0 || value.length > MAX_LENGTH) return false;
  if (!value.startsWith("/") || value.startsWith("//")) return false;
  // Browsers treat "\" as "/", so "/\evil.example" is protocol-relative. Control characters are
  // stripped by URL parsers, which can turn "/\t/evil.example" into "//evil.example".
  if (value.includes("\\") || hasControlCharacter(value)) return false;

  let url: URL;
  try {
    url = new URL(value, PROBE_ORIGIN);
  } catch {
    return false;
  }
  if (url.origin !== PROBE_ORIGIN) return false;

  const path = url.pathname.toLowerCase();
  return !LOOP_PATHS.some((loop) => path === loop || path.startsWith(`${loop}/`));
}
